import React from "react";
import InputField from "./InputFeild";

const SelectField = ({
 
  options,
  selectedValue,
  changeHandler,
  otherText = "Other",
  showOther = true,
  placeholder = "Select an option"
}) => {
  return (
    <div className="mr-3">
        <select
          value={selectedValue}
          onChange={(e) => changeHandler(e.target.value)}
          className="appearance-none block w-full  text-gray-700 border-2 border-gray-300 py-2 px-4 leading-tight focus:outline-none focus:bg-white"
          
        >
          <option disabled={true} value="">
           {placeholder}
          </option>
          {options.map((op) => (
            <option key={op.id} value={op.id}>
              {op.name}
            </option>
          ))}
          <option value="OTHER">{otherText}</option>
        </select>
      {selectedValue === "OTHER" && showOther && (
        <InputField type="text" label="Please Specify" />
      )}
    </div>
  );
};

export default SelectField;